"use client";
import ProjectCard from "./ProjectCard";
import projectsData from "../data.json";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function Projects() {
    // Standardize data from JSON
    const projects = projectsData
        .filter((p) => p.selected)
        .map((p) => ({
            name: p.name,
            summary: p.summary,
            techStack: p.techStack || [],
            link: p.slug ? `/projects/${p.slug}` : p.link || "#",
            thumbnail: p.thumbnail || p.images?.[0] || p.screenshot || "/image.png",
            github: p.github
        }));

    return (
        <section id="projects" className="py-24 relative overflow-hidden bg-black">
            {/* Ambient Background Glows */}
            <div className="absolute top-1/2 left-1/3 w-[30vw] h-[30vw] bg-[#ff5500]/3 rounded-full blur-[130px] mix-blend-screen pointer-events-none z-0" />

            <div className="container px-4 mx-auto max-w-7xl relative z-10">
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.6 }}
                    className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12"
                >
                    <div>
                        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">Selected Work</h2>
                        <p className="text-muted-foreground max-w-xl">
                            A collection of projects exploring performance, design, and user experience.
                        </p>
                    </div>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {projects.map((project, index) => (
                        <ProjectCard key={project.name} project={project} index={index} />
                    ))}
                </div>

                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="mt-16 text-center"
                >
                    <a
                        href="/projects"
                        className="group inline-flex items-center gap-2 px-8 py-3 rounded-full bg-white text-black hover:bg-gray-200 transition-all duration-300 font-medium hover:shadow-lg hover:shadow-white/10 hover:-translate-y-0.5"
                    >
                        View Project Archive
                        <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
                    </a>
                </motion.div>
            </div>
        </section>
    );
}
